import React, { useEffect, useRef, useState } from "react";
import { McModal, McButton, McSelect, McOption, McTextarea } from "@maersk-global/mds-react-wrapper/components-core";
import "./Model.css";
import { jwtDecode } from "jwt-decode";

const ActionModal = ({ open, onClose, chargeId, actionType, onSuccess, updateChargeInTable, isBot = false }) => {
  const modalRef = useRef(null);
  const prevOpenRef = useRef(false);

  const selectRef = useRef(null);
  const textareaRef = useRef(null);
  const [userInfo, setUserInfo] = useState(null);

  const [loading, setLoading] = useState(false);
  const [reasonError, setReasonError] = useState("");
const account = userInfo;
 useEffect(() => {
      // Example: get token from localStorage or API
      const token = localStorage.getItem(process.env.REACT_APP_CIAM_ACCESS_KEY);
  
      if (token) {
        try {
          const decoded = jwtDecode(token); // decode JWT
          setUserInfo(decoded.email);
        } catch (err) {
          console.error("Invalid token", err);
        }
      }
    }, []);

  // Open/close the modal imperatively
  useEffect(() => {
    const el = modalRef.current;
    if (!el) return;

    if (open && !prevOpenRef.current) {
      try { el.open = true; } catch { el.setAttribute("open", ""); }
      // Reset error state when modal opens
      setReasonError("");
    } else if (!open && prevOpenRef.current) {
      try { el.open = false; } catch { el.removeAttribute("open"); }
    }

    prevOpenRef.current = open;
  }, [open]);

  // Clear error when reason is selected
  useEffect(() => {
    const selectEl = selectRef.current;
    if (!selectEl) return;

    const handleChange = () => {
      if (selectEl.value) {
        setReasonError("");
      }
    };

    selectEl.addEventListener("input", handleChange);
    selectEl.addEventListener("change", handleChange);

    return () => {
      selectEl.removeEventListener("input", handleChange);
      selectEl.removeEventListener("change", handleChange);
    };
  }, []);

  const handleConfirm = async () => {
  if (!chargeId) return;

  const filterValue = selectRef.current?.value || "";
  const comments = textareaRef.current?.value || "";

  // Validate that rejection reason is selected
  if (!filterValue) {
    setReasonError("Please select a reason");
    return;
  }
  setReasonError("");

  setLoading(true); // Start loading
  try {
    const token = localStorage.getItem(process.env.REACT_APP_CIAM_ACCESS_KEY);
    const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/reject-return`, {
      method: "POST",
      headers: { "Authorization": `Bearer ${token}`, "Content-Type": "application/json" ,"consumer-key": process.env.REACT_APP_FORGEROCK_CONSUMER_KEY},
      body: JSON.stringify({ chargeId, filter: filterValue, comments, actionType ,userName:account || "unknown_user", isBot: isBot}),
    });

    const data = await res.json();

    if (updateChargeInTable) {
      updateChargeInTable(chargeId, data.updatedStatus, data.updatedComments);
    }

    onSuccess?.("Action completed successfully");
    onClose?.(); // Close modal only after response

  } catch (err) {
    alert("Failed to submit action. Please try again.");
  } finally {
    setLoading(false); // Stop loading
  }
};



  return (
    <McModal
      ref={modalRef}
      className="custom-modal"
      heading={`${actionType === "reject" ? "Reject" : "Return"} Charge`}
      dimension="medium"
      backdropCloseActionDisabled={false}
      escapeCloseActionDisabled={false}
      enterCloseActionDisabled={true}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "1rem", padding: "0.5rem 1rem 1rem" }}>
        <div style={{ position: "relative" }}>
          <McSelect
            ref={selectRef}
            placeholder="Select Reason"
            label="Reason *"
            defaultValue=""
            required
            invalid={!!reasonError}
          >
            <McOption value="Incorrect approver">Incorrect approver</McOption>
            <McOption value="Missing supporting documents, required details, incorrect information">
              Missing supporting documents, required details, incorrect information
            </McOption>
            <McOption value="Service is not accepted">Service is not accepted</McOption>
            <McOption value="Duplicate">Duplicate</McOption>
            <McOption value="Incorrect rate">Incorrect rate</McOption>
            <McOption value="Incorrect quantity">Incorrect quantity</McOption>
            <McOption value="To be billed to supplier/shipper">To be billed to supplier/shipper</McOption>
            <McOption value="Late request">Late request</McOption>
          </McSelect>
          {reasonError && (
            <span style={{ 
              color: "#d32f2f", 
              fontSize: "0.75rem", 
              position: "absolute",
              top: "100%",
              left: "0",
              marginTop: "0.125rem"
            }}>
              {reasonError}
            </span>
          )}
        </div>

        <McTextarea
          ref={textareaRef}
          label="Comments"
          placeholder="Enter your comments"
          multiline
          rows={3}
        />

        <span style={{ color: "#666", fontSize: "0.8rem", fontStyle: "italic", marginTop: "-0.5rem" }}>
          * marked fields are mandatory
        </span>

        <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.75rem", marginTop: "0.5rem" }}>
          <McButton
            slot="secondaryAction"
            appearance="neutral"
            fit="medium"
            dialogaction="cancel"
            onClick={onClose}
          >
            Cancel
          </McButton>
        <McButton
  slot="primaryAction"
  appearance="primary"
  fit="medium"
  // Remove dialogaction
  onClick={handleConfirm}
  disabled={loading}
>
  {loading ? "Submitting..." : "Confirm"}
</McButton>


        </div>
      </div>
    </McModal>
  );
};

export default ActionModal;
